import { Theme } from '@mui/material';


const TextField = (theme: Theme) => {
  return {
    MuiTextField: {
      defaultProps: {
        fullWidth: true,
      },
      styleOverrides: {
        root: {
          'fieldset': {
            borderColor: '#e2e8f0',
            borderRadius: '10px',
          },
          resize: 'vertical',
        },
      },
    },
  };
};

export default TextField;
